module.exports = __webpack_public_path__ + "static/img/院史馆.64814ef8.png";